import { UPDATE_QC_ALL_SUBMIT, UPDATE_QC_ALL_SUBMIT_ERR } from 'context/actionTypes/qcType';
import { updateQcAllSubmitApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const updateQcAllSubmit = (payload) => async (dispatch) => {
    try {
        //console.log(payload)
        let results = await axios.put(`${updateQcAllSubmitApi}`, payload, await accessToken())
        //console.log(results)
        let data = results && results.data
        //console.log('UPDATE STEP 1 JOB', data)
        dispatch({
            type: UPDATE_QC_ALL_SUBMIT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_QC_ALL_SUBMIT_ERR,
            payload: error.response,
        });
    }
};